export const getItemQuantityPhrase = (singleItem: boolean = true): string => (singleItem ? 'this item' : 'these items');
export const getItemStatePhrase = (singleItem: boolean = true): string => (singleItem ? 'item is' : 'items are');
export const pluraliseItemWord = (singleItem: boolean = true): string => `item${(singleItem ? '' : 's')}`;
export const pluraliseQuantityWord = (singleItem: boolean = true): string => (singleItem ? 'quantity' : 'quantities');
